import { Component } from '@angular/core'

@Component({
    selector: 'layout-public',
    template: `
    <router-outlet></router-outlet>
  `,
    standalone: false
})
export class LayoutPublicComponent {}
